namespace app.tarefas.minhasTarefas {

    import IDialogService = ng.material.IDialogService;
    import AuthService = app.autenticacao.AuthService;

    export class CreateTagController {

        public color: string = "#0000ff";
        public name: string;
        public tooltip: string;
        public tenants: Tenant[] = [];
        public nameTenant = "";
        public tenantsSelects: Tenant[] = [];
        public searched: boolean;

        /** @ngInject **/
        constructor(private $mdDialog: IDialogService,
            private authService: AuthService) { 
                this.searchTenant();
            }

        public createTag(): void {
            let tenantsList = this.tenantsSelects.map(tenant => tenant.codigo);
            this.$mdDialog.hide({ color: this.color, name: this.name, tooltip: this.tooltip, tenantsPermitidos: tenantsList });
        }

        public closeDialog(): void {
            this.$mdDialog.cancel();
        }

        public searchTenant(): void {
            this.authService
                .getUser()
                .then(user => {
                    this.tenants = user.contas;                    
                });
        }

    }

    angular
        .module("app.tarefas.minhas-tarefas")
        .controller("app.tarefas.minhas-tarefas.CreateTagController", CreateTagController);
}